// Value of the "All" chip. Hosts seed their own filter defaults from this so the
// chip row and the host agree on what "no category filter" means.
export const DEFAULT_CATEGORY = 'all'

// Delay before a typed search reaches the gallery query, so typing does not fire a
// request per keystroke. Shared by the 3D and image galleries.
export const SEARCH_DEBOUNCE_MS = 500
